module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/admin/icontact/video-call/video-call.component.css
// module id = ./src/app/pages/admin/icontact/video-call/video-call.component.css
// module chunks = main